import { Dialog, DialogContent, DialogTrigger } from "../../components/ui/dialog";
import { LeadForm } from "./LeadForm";
import { ReactNode } from "react";

interface LeadFormDialogProps {
  children: ReactNode;
  utms:[]
}

export const LeadFormDialog = ({ children, utms }: LeadFormDialogProps) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <LeadForm utms={utms} />
      </DialogContent>
    </Dialog>
  );
};
